export const DepartmentHeaders = [
  { key: '_id', label: 'Department ID' },
  { key: 'name', label: 'Name' }
];
